<script setup>
import { onMounted } from "vue";

import Grid from "../components/Grid.vue";
import GridItemPercentage from "../components/GridItemPercentage.vue";
import anime from "animejs/lib/anime.es.js";

import { useMenuInfoStore } from "../stores/menu-info";
const menuInfoStore = useMenuInfoStore();

menuInfoStore.getMenuInfo();

onMounted(() => {
  anime({
    targets: ".grid-item, .grid-item--percentage, .menu-cards .menu",
    translateY: ["20px", 0],
    scale: [0.98, 1],
    opacity: [0, 1],
    delay: anime.stagger(100),
  });
});
</script>

<template>
  <div class="dashboard content__inside">
    <div class="content__header">
      <div>
        <h1>Hello {{ auth.user?.name }}</h1>
        <p>Welcome Back!</p>
      </div>
    </div>
    <Grid :columns="'1fr 2fr'" class="grid-main">
      <div class="grid-item grid-list-resturants">
        <ul class="site-list">
          <li>
            <h3>Restaurant</h3>
            <h3>Updated At</h3>
          </li>
          <li>
            <div class="site">
              <img src="@img/tevalis.png" alt="" />
              <p>Tevalis API</p>
            </div>
            <p>{{ menuInfoStore.tevalis_updated }}</p>
          </li>
          <li v-for="site in menuInfoStore.sites">
            <div class="site">
              <img v-if="site.url" :src="`https://www.google.com/s2/favicons?domain=${site.url}&sz=32`" alt="" />
              <p class="text-left">{{ site.name }}</p>
            </div>
            <p>{{ site.updated_at }}</p>
          </li>
        </ul>
      </div>
      <Grid class="grid-data-outer">
        <Grid :columns="'repeat(2, 1fr)'" :textAlign="'center'" class="grid-data-resturants">
          <div class="grid-item">
            <Grid :columns="'repeat(2, 1fr)'" :align="'center'" :textAlign="'center'">
              <div>
                <p class="grid-item__value">{{ menuInfoStore.menus }}</p>
                <p>Menu Types</p>
              </div>
              <div>
                <p class="grid-item__value">{{ menuInfoStore.sites.length }}</p>
                Venues
              </div>
            </Grid>
          </div>
          <div class="grid-item">
            <Grid :columns="'1fr'" :align="'center'" :textAlign="'center'" class="grid-dish-total">
              <div>
                <p class="grid-item__value">{{ menuInfoStore.dishes }}</p>
                <p>Total number of dishes</p>
              </div>
            </Grid>
          </div>
        </Grid>
        <Grid :columns="'repeat(3, 1fr)'" class="grid-dish-percentage">
          <GridItemPercentage :text="'Halal Dishes'" :color="'var(--black)'" :value="menuInfoStore.halal">
          </GridItemPercentage>
          <GridItemPercentage :text="'Kosher Dishes'" :color="'var(--blue-dark)'" :value="menuInfoStore.kosher">
          </GridItemPercentage>
          <GridItemPercentage :text="'Vegetarian Dishes'" :color="'var(--blue-mid)'" :value="menuInfoStore.vegetarian">
          </GridItemPercentage>
          <GridItemPercentage :text="'Vegan Dishes'" :color="'var(--blue-light)'" :value="menuInfoStore.vegan">
          </GridItemPercentage>
          <GridItemPercentage :text="'Gluten Free Dishes'" :color="'var(--green)'" :value="menuInfoStore.glutenFree">
          </GridItemPercentage>
          <GridItemPercentage :text="'Spicy Dishes'" :color="'var(--orange)'" :value="menuInfoStore.spicy">
          </GridItemPercentage>
        </Grid>
      </Grid>
    </Grid>
  </div>
</template>

<style scoped lang="scss">
.dashboard {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.text-left {
  text-align: left !important;
  ;
}
</style>
